export const ROLE_AR = {
  admin: 'إدارة',
  supervisor: 'مشرف',
  team: 'فريق',
  client: 'عميل',
};

export const isAdmin = (user) => user?.role === 'admin';
export const isSupervisor = (user) => user?.role === 'supervisor';
export const isManager = (user) => user?.role === 'admin' || user?.role === 'supervisor';
export const isStaff = (user) => ['admin', 'supervisor', 'team'].includes(user?.role);
export const roleLabel = (role) => ROLE_AR[role] || role || '';
export const hasPermission = (user, key) => Array.isArray(user?.permissions) && user.permissions.includes(key);
export const isAssignable = (user) => ['admin', 'supervisor', 'team'].includes(user?.role);

